<template>
  <div class="digital-today-order-page">
    <div class="chart-block">
      <!-- <img src="/static/images/digitalarea/drddgk.png" class="titl"> -->
      <div class="chart-box">
        <v-chart :options="options_ddgk" />
      </div>
      <div class="bottom-block">
        <div class="bd">
          <div class="itm">总任务量：<span class="dnum"><span v-text="taskTotal"></span>个</span></div>
          <!-- <div class="itm">执行中：<span class="dnum">30个</span></div>
          <div class="itm">已完成：<span class="dnum">45个</span></div>
          <div class="itm">待执行：<span class="dnum">650个</span></div> -->
          <div class="itm" v-for="(item, key) in ddgkList"><span class="label" v-text="ddgkLabel[key]+'：'"></span><span class="dnum"><span v-text="item"></span>个</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts/lib/echarts'
export default{
  data() {
    return {
      taskTotal: 0,
      ddgkLabel: {},
      ddgkList: {},
      options_ddgk: {},
    }
  },
  mounted() {
    //定义全局方法
    window.gbfc_resetData = this.resetData;
    //初始化
    this.$initPage(this);
  },
  methods: {
    resetData() {
      //库区周转率
      this.getDdgkList();
    },
    getDdgkList(){
      let self = this;
      this.ddgkLabel = {
        FinishedCount: "已完成",
        ExcutingCount: "执行中",
        ToExcuteCount: "待执行",
      }
      this.$handleRequest(window.ApiHost1+'/api/DataStatistical/TodayOrders_Count', {
        "WareHouseCode": window.PYKWareHouseCode,
        "Date": this.$formatDateTime(null, 'yyyy-MM-dd'),
        "OrderNo": "",
      }, 'post', function(res) {  //success

      console.log(res)
        self.ddgkList = res.retData;
        self.setOptionsDdgk();
      }, function(res) {
        //fail
      });
    },
    setOptionsDdgk() {
      let colors = this.$charts.colors.style_2;
      let chartsConf = this.$charts[window.CurrentTheme];
      let sdata = [];
      let di = 0;
      let taskTotal = 0;
      for(let key in this.ddgkList) {
        let countVal = Math.floor(this.ddgkList[key] * 100) / 100;
        taskTotal += countVal;
        let color1 = colors[di][0];
        let color2 = colors[di][1];
        let tmp = {
          value: countVal,
          name: (this.ddgkLabel[key] ? this.ddgkLabel[key] : key),
          label: {
            normal: {
                rich: {
                  hr: {
                    borderColor: color2
                  },
                  per: {
                    color: color1
                  }
                }
            }
          },
          itemStyle:{
            normal:{
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {offset: 0, color: color1}, {offset: 1, color: color2}
              ])
            }
          }
        };
        sdata.push(tmp);
        di ++;
      }
      this.taskTotal = taskTotal;

      this.options_ddgk = {
        series: [
          {
            type:'pie',
            radius: ['38%', '55%'],
            center: ['50%', '57%'],
            avoidLabelOverlap: true,
            labelLine: {
              //length: 30,
              length2: 25
            },
            label: {
              normal: {
                  formatter: '{per|{d}%} \n{hr|}\n {b|{b}}',
                  backgroundColor: chartsConf.series.backgroundColor,
                  padding: 10,
                  borderColor: chartsConf.series.borderColor,
                  borderWidth: 1,
                  rich: {
                    /*hr: {
                      //borderColor: '#fff',
                      width: '100%',
                      borderWidth: 0.5,
                      height: 0,
                    },*/
                    b: {
                      fontSize: 20,
                      color: chartsConf.series.color,
                      //padding: [0, 0, 0, 0]
                    },
                    per: {
                      align: 'center',
                      fontSize: 24,
                      //padding: [0, 0, 0, 0]
                    }
                  }
              }
            },
            data: sdata
          }
        ]
      };
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/xiayan/digitalarea/TodayOrder.vue